
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/creating-more-thoughtful-communication-culture-delayedsend",
      function () {
        return require("private-next-pages/article/creating-more-thoughtful-communication-culture-delayedsend.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/creating-more-thoughtful-communication-culture-delayedsend"])
      });
    }
  